import React from 'react';

import styles from '../Style/FeaturesComponents.module.scss';

export type tableObject = {
  text: string;
  exampleText?: string;
  image?: {
    src: string;
    alt: string;
    imageSize?: {
      width: string;
      height: string;
    };
  };
  link?: {
    text: string;
    href: string;
  };
  type?: 'image' | 'link' | 'text' | 'file';
};

type PrivateProps = {
  th1: string;
  th2: string;
  tableObjects: tableObject[];
  theme?: 'light';
};

export function Table({ th1, th2, tableObjects, theme }: PrivateProps) {
  return (
    <table className={`${styles.table} ${theme ? styles.light : ''}`}>
      <thead>
        <tr>
          <th>{th1}</th>
          <th>{th2}</th>
        </tr>
      </thead>
      <tbody>
        {tableObjects.map((data, index) => {
          return (
            <tr key={`table-tr-${index}`}>
              <td>{data.text}</td>
              <td>
                {data.image && (
                  <a href={data.image.src} target={'_blank'} rel={'noreferrer'}>
                    <div
                      style={{
                        width:
                          data?.image?.imageSize != undefined
                            ? data.image.imageSize.width
                            : '300px',
                        height:
                          data?.image?.imageSize != undefined
                            ? data.image.imageSize.height
                            : 'unset',
                      }}
                      className={styles.imageContainer}
                    >
                      <img src={data.image.src} alt={data.image.alt} />
                    </div>
                  </a>
                )}
                {data.link && (
                  <a href={data.link.href} download={data.type === 'file'}>
                    {data.link.text}
                  </a>
                )}
                {data.exampleText && <span>{data.exampleText}</span>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
